import {Constants} from 'core/constants';

/**
 * @module SalesFlow/evolved/view
 */
import {
    SwitcherDataInterface,
    ViewEvolvedElementSharedTariffgroupSwitcher
} from 'view-evolved/element/shared/view-evolved--element-shared--tariffgroup-switcher';

declare var $: JQueryStatic;

/**
 * TariffGroup is a combination of SaleChannel + SubscriptionGroup
 */

export class ViewEvolvedElementBntTariffGroupSwitcher extends ViewEvolvedElementSharedTariffgroupSwitcher {

    protected getSwitcherData (): SwitcherDataInterface[] {

        return [
            {
                salesChannel: Constants.SALESCHANNEL_CONSUMER,
                subscriptionGroup: Constants.SUBSCRIPTION_GROUP_RED,
                name: 'Red-Tarife',
                active: false
            },
            {
                salesChannel: Constants.SALESCHANNEL_YOUNG,
                subscriptionGroup: Constants.SUBSCRIPTION_GROUP_YOUNG,
                name: 'Unter 28 Jahren?',
                active: false
            },
            {
                salesChannel: Constants.SALESCHANNEL_CONSUMER,
                subscriptionGroup: Constants.SUBSCRIPTION_GROUP_IN,
                name: 'Flex-Tarif',
                active: false
            },
            {
                salesChannel: Constants.SALESCHANNEL_SOHO,
                subscriptionGroup: Constants.SUBSCRIPTION_GROUP_RED,
                name: 'Selbständig?',
                active: false
            }
        ];
    }
}
